<section class="p-2 p-md-4">
  <div class="card mb-4">
    <div class="card">
      <div class="card-header bg-white row justify-content-between">
        <div class="col-6 mt-3">

          <h3>Deseja inserir uma consulta realizada anteriormente?</h3>
        </div>
        <div class="col-6">
          <p-selectButton
            class="selectButton"
            [options]="stateOptions"
            [(ngModel)]="desejaResgatar"
            (onChange)="funcDesejaResgatar()"
            optionLabel="label"
            optionValue="desejaResgatar"
          ></p-selectButton>
        </div>

        <h3>Placa : {{placa}}</h3>

      </div>

      <div *ngIf="desejaResgatar">
        <div class="card-header bg-white row justify-content-between">
          <div class="col-12">
            <h3>Regras para resgate da consulta para laudo</h3>
            <div class="col-12 p-4">
              <p>
                * A consulta deverá pertencer à mesma configuração do laudo.
              </p>
              <p>
                * O prazo para ser resgatada será de 72 horas a contar da data
                da realização da consulta.
              </p>
              <p>* A consulta não deve pertencer a outro laudo já existente.</p>
            </div>
          </div>
        </div>

        <div class="card-body row">
          <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 mt-2">
            <h3>Insira o ID da consulta</h3>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
            <input
              required
              autocomplete="off"
              type="number"
              class="form-control input-validate"
              name="id"
              id="id"
              [formControl]="form.controls.id"
            />
            <app-msg-erro [control]="form.controls.id"></app-msg-erro>
          </div>
        </div>
      </div>

      <div class="card-footer d-flex justify-content-between">
        <button (click)="fecharModal()" class="btn btn-lg btn-info px-lg-5">
          Cancelar
        </button>
        <button
          [disabled]="desejaResgatar && form.invalid"
          (click)="realizarConsulta()"
          class="btn btn-lg btn-success px-lg-5"
        >
          Confirmar
        </button>
      </div>
    </div>
  </div>
</section>
